define('views/modules/calendar/personal-data/item/personal-data-panel',[
    // Libs
    'underscore', 'backbone', 'utils',
    // Views
    'views/modules/calendar/calendar-item-panel',
    'views/modules/feedback/feedback',
    'views/modules/calendar/personal-data/item/personal-data-content',
], function(
    // Libs
    _, Backbone, U,
    // views
    VCalendarItemPanel,
    VFeedback,
    VPersonalDataDetails
) {

    var VPersonalDataPanel = VCalendarItemPanel.extend({
        header: {
            title: "calendar:Personal data",
            subtitle: "calendar:Add/Modify a personal data",
        },
        tabs: [
            { id: 'details', title: 'Details', icon: 'sl-icon-info', active: true, callback: 'showDetails' },
            { id: 'feedback', title: 'calendar:Feedback', icon: 'sl-icon-bubbles', callback: 'showFeedback' },
        ],
        content: {
            details: VPersonalDataDetails,
            feedback: VFeedback,
        },
    });

    return VPersonalDataPanel;
});

